import React from "react";

import Text from "src/components/text";

import { Analytics, CollectionItem } from "src/types/reports";

import _ from "lodash";
import cx from "classnames";
import styles from "./collectionListItem.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface CollectionActivityItem {
  collection: CollectionItem;
  analytics: Analytics;
}

export interface CollectionListItemProps {
  item: CollectionActivityItem;
  columnCount: number;
}

export const CollectionListItem: React.FC<CollectionListItemProps> = ({
  item,
  columnCount,
}) => {
  const { collection, analytics } = item;

  const createdBy = collection.createdBy?.firstName
  ? `${collection.createdBy.firstName} ${collection.createdBy.lastName || ""}`.trim()
  : "Unknown";

  return (
    <div key={collection.id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={collection.icon?.thumbnail || DefaultAssetIcon}
          alt={collection.name}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/collections/${collection.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                lines={1}
                className={styles.title}
                text={collection.name || ""}
              />
            </div>
            <span className={styles.metricsData}>
              <span className={styles.name}>
                {collection.assetsCount || 0} Assets
              </span>
            </span>
          </div>
        </a>
      </div>
      <div
        className={cx(styles.analyticsContainer)}
        style={{ gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))` }}
      >
        <div className={styles.tableDataViews}>
          <Text lines={1} className={styles.author} text={createdBy} />
        </div>
        <div className={styles.tableDataViews}>
        {collection.createdDate &&
            new Date(collection.createdDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
        </div>
        <div className={styles.tableDataViews}>
        {collection.modifiedDate &&
            new Date(collection.modifiedDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
        </div>
        <div className={styles.tableDataShares}>{analytics.shares}</div>
        <div className={styles.tableDataViews}>{analytics.views}</div>
      </div>
    </div>
  );
};
